import { createReducer, on } from '@ngrx/store';
import {
  ActiveComponentChanged,
  ResetStateFromRouter,
} from 'src/app/shared/actions/eliqua.actions';
import {
  AmountChanged,
  BookCouponTemplateChanged,
  CloseCreateNewSidenav,
  CouponSetChanged,
  CurrencyChanged,
  DiscountChanged,
  GetBookCouponTemplatesSuccess,
  GetCouponSetsSuccess,
  GetCurrenciesSuccess,
  GetMemberCategoriesSuccess,
  GetMemberStatusesSuccess,
  GetMemberTagsSuccess,
  GetRedemptionTypesSuccess,
  MemberCategoryChanged,
  MemberStatusChanged,
  MemberTagChanged,
  MessageChanged,
  OpenCreateNewSidenav,
  OpenEditSidenav,
  PointsChanged,
  RedemptionTypeChanged,
  SchemaChanged,
  SubmitCreateNew,
  SubmitCreateNewFailed,
  SubmitCreateNewSuccess,
} from '../actions/create-new.actions';
import { CreateNewState } from '../models/create-new.model';

const initialState: CreateNewState = {
  sidenavStatus: false,
  isEdit: false,
  editRuleIndex: null,
  redemptionTypes: [],
  memberCategories: [],
  memberStatuses: [],
  memberTags: [],
  currencies: [],
  couponSets: [],
  bookCouponTemplates: [],
  schemaCode: '',
  schemaId: null,
  redemptionType: '',
  memberCategoryCode: '',
  memberStatusCode: '',
  memberTagCode: '',
  points: null,
  amount: null,
  currency: '',
  discount: null,
  couponSetCode: '',
  bookCouponTemplateCode: '',
  message: '',
  submitted: false,
};

export const CreateNewReducer = createReducer(
  initialState,
  on(OpenCreateNewSidenav, (state) => ({
    ...state,
    sidenavStatus: true,
    isEdit: false,
    editRuleIndex: null,
    submitted: false,
    redemptionType: '',
    memberCategoryCode: '',
    memberStatusCode: '',
    memberTagCode: '',
    points: null,
    amount: null,
    currency: '',
    discount: null,
    couponSetCode: '',
    bookCouponTemplateCode: '',
    message: '',
  })),
  on(OpenEditSidenav, (state, { rule, ruleIndex }) => ({
    ...state,
    sidenavStatus: true,
    isEdit: true,
    editRuleIndex: ruleIndex,
    submitted: false,
    redemptionType: rule.redemptionType || '',
    memberCategoryCode: rule.memberCategoryCode || '',
    memberStatusCode: rule.memberStatusCode || '',
    memberTagCode: rule.memberTagCode || '',
    points: rule.points,
    amount: rule.amount,
    currency: rule.currency || '',
    discount: rule.discount,
    couponSetCode: rule.couponSetCode || '',
    bookCouponTemplateCode: rule.bookCouponTemplateCode || '',
    message: rule.message || '',
  })),
  on(CloseCreateNewSidenav, (state) => ({
    ...state,
    sidenavStatus: false,
    submitted: false,
  })),
  on(GetRedemptionTypesSuccess, (state, { res }) => ({
    ...state,
    redemptionTypes: res,
  })),
  on(GetMemberCategoriesSuccess, (state, { res }) => ({
    ...state,
    memberCategories: res,
  })),
  on(GetMemberStatusesSuccess, (state, { res }) => ({
    ...state,
    memberStatuses: res,
  })),
  on(GetMemberTagsSuccess, (state, { res }) => ({
    ...state,
    memberTags: res,
  })),
  on(GetCurrenciesSuccess, (state, { res }) => ({
    ...state,
    currencies: res,
  })),
  on(GetCouponSetsSuccess, (state, { res }) => ({
    ...state,
    couponSets: res,
  })),
  on(GetBookCouponTemplatesSuccess, (state, { res }) => ({
    ...state,
    bookCouponTemplates: res,
  })),
  on(SchemaChanged, (state, { schemaCode, schemaId }) => ({
    ...state,
    schemaCode,
    schemaId,
    couponSets: [],
    bookCouponTemplates: [],
    couponSetCode: '',
    bookCouponTemplateCode: '',
  })),
  on(RedemptionTypeChanged, (state, { redemptionType }) => ({
    ...state,
    redemptionType,
    amount: null,
    currency: '',
    discount: null,
    couponSetCode: '',
    bookCouponTemplateCode: '',
    message: '',
  })),
  on(MemberCategoryChanged, (state, { memberCategoryCode }) => ({
    ...state,
    memberCategoryCode,
  })),
  on(MemberStatusChanged, (state, { memberStatusCode }) => ({
    ...state,
    memberStatusCode,
  })),
  on(MemberTagChanged, (state, { memberTagCode }) => ({
    ...state,
    memberTagCode,
  })),
  on(PointsChanged, (state, { points }) => ({
    ...state,
    points,
  })),
  on(AmountChanged, (state, { amount }) => ({
    ...state,
    amount,
  })),
  on(CurrencyChanged, (state, { currency }) => ({
    ...state,
    currency,
  })),
  on(DiscountChanged, (state, { discount }) => ({
    ...state,
    discount,
  })),
  on(CouponSetChanged, (state, { couponSetCode }) => ({
    ...state,
    couponSetCode,
  })),
  on(BookCouponTemplateChanged, (state, { bookCouponTemplateCode }) => ({
    ...state,
    bookCouponTemplateCode,
  })),
  on(MessageChanged, (state, { message }) => ({
    ...state,
    message,
  })),
  on(SubmitCreateNew, (state) => ({
    ...state,
    submitted: true,
  })),
  on(SubmitCreateNewSuccess, () => initialState),
  on(SubmitCreateNewFailed, (state) => ({
    ...state,
    submitted: false,
  })),
  on(ActiveComponentChanged, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState,
  })),
);
